import { reducer as toastr } from 'react-redux-toastr'
import { combineReducers } from 'redux'

import statics from 'store/statics/staticsReducer'

export const appReducer = combineReducers({
  statics,
  toastr,
})
